import script from "./VideoSearchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSearchResult.vue?vue&type=script&setup=true&lang=js"

import "./VideoSearchResult.vue?vue&type=style&index=0&id=49b60151&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b60151"]])

export default __exports__